import { SearchBar, Toolbox } from 'redesign';
import { useMemo, useState } from 'react';
import { FilterButton } from 'ogp/components/views/administration/shared';
import { Box } from '@mui/material';
import { EmploymentType } from '@types';
import { FlexWorkersForShiftFilterOptions } from 'shared/components/flex-workers-for-work-table/flex-workers-for-work.types';
import { useDebounce } from 'shared/hooks/use-debounce';
import { ShiftAddFlexWorkerFilters } from './shift-add-flex-worker-filters';
import { ShiftAddFlexWorkerTableProviderHQ } from './shift-add-flex-worker-table-provider-hq';
import { ShiftAddFlexWorkerTableProviderOGP } from './shift-add-flex-worker-table-provider-ogp';
import { FlexWorkerTableOptions } from '../../../../flex-workers-for-work-table/flex-workers-for-work-table.types';

type Props = {
  shiftDetails: {
    shiftId: string;
    isFreelance: boolean;
    isTempWork: boolean;
    isEmployee: boolean;
  };
  getRowActions: FlexWorkerTableOptions['getRowActions'];
  isActorOGPUser?: boolean;
};

const employmentTypeFilters = [
  EmploymentType.FREELANCER,
  EmploymentType.TEMPWORKER,
  EmploymentType.EMPLOYEE,
];

export const ShiftAddFlexWorker = ({ isActorOGPUser = true, ...props }: Props) => {
  const [searchInput, setSearchInput] = useState<string>('');
  const debouncedSearchInput = useDebounce(searchInput, 800);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [filterValues, setFilterValues] = useState<FlexWorkersForShiftFilterOptions>({
    isFreelancer: props.shiftDetails.isFreelance,
    isTempWorker: props.shiftDetails.isTempWork,
    isEmployee: props.shiftDetails.isEmployee,
  });

  const handleOpeneningFilters = (val: boolean) => {
    setIsOpen(val);
  };

  const numberOfAppliedFilters = useMemo(
    () => Object.values(filterValues).filter((f) => f !== undefined && f !== '0' && f).length,
    [filterValues]
  );

  return (
    <>
      <Box display="flex" marginTop={4} marginBottom={8}>
        <SearchBar onChange={setSearchInput} placeholder="Flex werker naam" />
        <Toolbox.PushRight>
          <ShiftAddFlexWorkerFilters
            handleOpeneningFilters={handleOpeneningFilters}
            isOpen={isOpen}
            setFilterValues={setFilterValues}
            filterValues={filterValues}
            allowedEmploymentTypes={employmentTypeFilters}
          />
          <FilterButton
            onClick={() => handleOpeneningFilters(true)}
            nrOfActiveFilters={numberOfAppliedFilters}
          />
        </Toolbox.PushRight>
      </Box>
      {isActorOGPUser ? (
        <ShiftAddFlexWorkerTableProviderOGP
          filters={{ fullNameSearch: debouncedSearchInput || undefined, ...filterValues }}
          {...props}
          shiftId={props.shiftDetails.shiftId}
        />
      ) : (
        <ShiftAddFlexWorkerTableProviderHQ
          filters={{ fullNameSearch: debouncedSearchInput || undefined, ...filterValues }}
          {...props}
          shiftId={props.shiftDetails.shiftId}
        />
      )}
    </>
  );
};
